// extracted by mini-css-extract-plugin
module.exports = {"container":"OmOss_container__3tb67","title":"OmOss_title__1f5nA","sub":"OmOss_sub__2gFYY"};